import { Switch, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { TenantConfigContext } from 'context/TenantConfigContext';
import { useTokenPermissions } from 'hooks/useTokenPermissions';
import { TenantSelect } from 'components/TenantSelect';
import { LastUpdatedChip } from 'components/LastUpdatedChip';

import { useTenantList } from 'services/rest-api.service';
import { TenantData } from 'models/tenants';
import { AccountMenu } from 'components/Sidebar/AccountMenu';
import { Breadcrumb } from 'components/breadcrumb/Breadcrumb';
import { TbIcon } from 'components/Figma';

interface TopHeaderProps {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
}

export function TopHeader({ sidebarCollapsed, toggleSidebar }: TopHeaderProps) {
  const { accountNumber, isAdminView, setAdminView } = useContext(TenantConfigContext);
  const [tokenPermissions] = useTokenPermissions();
  const [isAdminRole, setAdminRole] = useState<boolean>(false);

  const [tenantList, setTenantList] = useState<TenantData[]>();
  const tenantService = useTenantList();

  useEffect(() => {
    setAdminRole(tokenPermissions.toString().includes('read:all_accounts'));
  }, [tokenPermissions]);

  useEffect(() => {
    if (isAdminRole) {
      tenantService.getAll().then(({ data }) => setTenantList(data ?? []));
    }
  }, [isAdminRole]);

  return (
    <div className="sticky top-0 z-40 h-16 bg-snow-200">
      <header className="h-14 flex items-center justify-between px-3">
        <div className="flex items-center gap-3 flex-1">
          <button
            type="button"
            onClick={toggleSidebar}
            id="sidebar-collapse-expand-trigger"
            className="hover:bg-denim-50 rounded transition-colors flex items-center justify-center p-1"
            aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {sidebarCollapsed ? <TbIcon name="MenuExpand" size="xl" /> : <TbIcon name="MenuCollapse" size="xl" />}
          </button>
          <div className="flex flex-row items-center gap-0.5">
            <Breadcrumb />
          </div>
        </div>

        <div className="flex items-center gap-4">
          <LastUpdatedChip />
          {isAdminRole && (
            <div className="flex items-center gap-2">
              <Typography variant="body2" sx={{ color: '#4b5563', fontSize: '0.75rem', whiteSpace: 'nowrap' }}>
                Admin View
              </Typography>
              <Switch checked={isAdminView} onChange={e => setAdminView(e.target.checked)} />
            </div>
          )}

          {isAdminRole && tenantList && (
            <div className="w-[200px] min-w-[200px] max-w-[200px] shrink-0">
              <TenantSelect selectedTenant={accountNumber} allTenants={tenantList} />
            </div>
          )}

          <AccountMenu />
        </div>
      </header>
      <div className="bg-white h-4 rounded-tl-lg"></div>
    </div>
  );
}
